import PropTypes from 'prop-types';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';

import { TRADE_RULE_STATE_CANCELLED } from 'src/util/constants';

import TradeRuleTimelineStep from './TradeRuleTimelineStep';

/**
 * Description
 * @param {any} props
 * @returns {any} - TradeRuleTimelineStepCancelled component
 */
function TradeRuleTimelineStepCancelled(props) {
  const {
    ruleId, tradeType, timestamp, user, isCurrentStep, hasNextStep,
    propertyTimeZone,
  } = props;

  return (
    <TradeRuleTimelineStep
      timezone={propertyTimeZone}
      ruleId={ruleId}
      tradeType={tradeType}
      state={TRADE_RULE_STATE_CANCELLED}
      timestamp={timestamp}
      user={user}
      icon={<FontAwesomeIcon icon={faBan} />}
      isCurrentStep={isCurrentStep}
      hasNextStep={hasNextStep}
    />
  );
}

TradeRuleTimelineStepCancelled.propTypes = {
  ruleId: PropTypes.string.isRequired,
  propertyTimeZone: PropTypes.string.isRequired,
  tradeType: PropTypes.string.isRequired,
  timestamp: PropTypes.number.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    givenName: PropTypes.string,
    familyName: PropTypes.string,
  }).isRequired,
  isCurrentStep: PropTypes.bool.isRequired,
  hasNextStep: PropTypes.bool.isRequired,
};

TradeRuleTimelineStepCancelled.defaultProps = {
};

export default TradeRuleTimelineStepCancelled;
